import apiClient from "./apiClient";

export const chatService = {
  /**
   * Send user prompt to the AI Chatbot
   * @param {Object} payload - { message, history, conversationId, signal }
   */
  async sendMessage({ message, history = [], conversationId, signal }) {
    const response = await apiClient.post(
      "/chat/message",
      {
        message,
        history,
        conversationId,
      },
      { signal }
    );
    return response.data?.data || response.data;
  },

  /**
   * Get chatbot engine & model status
   */
  async getStatus() {
    const response = await apiClient.get("/chat/status");
    return response.data?.data || response.data;
  },
};

export default chatService;
